import React from "react";
import { getUser } from "../../../core/Global";
import { UserTypes } from "../../../core/Enums";
import AdminDashboard from "./AdminDashboard";
import DashboardView from "./DashboardView";

function DashboardRouter() {
    const user = getUser();
    const t = user?.userType;
    if (t === UserTypes.Admin || t === UserTypes.Customer) {
        return <AdminDashboard />;
    }
    return <DashboardView />;
}

export default DashboardRouter;
